import { CR_EVENT } from '@/customTypes/tracking/gtm';

export const GA4_CONTAINER_ID = process.env.NEXT_PUBLIC_GA4_CONTAINER_ID;
export const GTM3_CONTAINER_ID = process.env.NEXT_PUBLIC_GTM3_CONTAINER_ID;

declare const window: Window &
  typeof globalThis & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer: any;
  };

export interface GtmEvent {
  [key: string]: unknown;
}
export interface GtmUserAttributes {
  memberId: number;
  emailaddr: string;
  uid: string;
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageView = (url: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.dataLayer.push('config', GA4_CONTAINER_ID, {
    pageView: url,
  });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const TrackGA4Event = <T>(event: CR_EVENT, eventData: T) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.dataLayer.push({
    event,
    attributes: {
      ...eventData,
    },
  });
};

export const saveGA4UserAttributes = (attributies: GtmUserAttributes) => {
  window.dataLayer.push(attributies);
};
